import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';

@Component({
	selector: 'app-place-ad-stepper',
	templateUrl: './place-ad-stepper.component.html',
	styleUrls: ['./place-ad-stepper.component.scss'],
})
export class PlaceAdStepperComponent implements OnInit {
	constructor(private router: Router, private route: ActivatedRoute, public locale: LocaleService, public viewport: ViewportService) {}

	currentRoute: string;

	ngOnInit(): void {
		if (this.router['url'].includes('placead')) {
			this.currentRoute = 'placead';
		} else if (this.router['url'].includes('login') || this.router['url'].includes('login')) {
			this.currentRoute = 'login';
		}
	}
}
